import { render, staticRenderFns } from "./BusinessEntitiesList.vue?vue&type=template&id=7c4f84ea"
import script from "./BusinessEntitiesList.vue?vue&type=script&lang=js"
export * from "./BusinessEntitiesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports